import React from 'react';
import Common from '../Common/common';

const TicketIssuePaidList = ({ ticket_issuelist, ticketIssueClick }) => {
  return (
    <div id="ticketPaidList" className="ticket-issuelist">
      {ticket_issuelist && ticket_issuelist.map((ticket, index) => {
        return (
          <React.Fragment key={`${ticket.ticket_id}-${ticket.issue_count}`}>
          <div key={`${ticket.ticket_id}-${ticket.issue_count}`} className="ticket-point-box">
            <div className="frame100">
              <div className="use-point">{ticket.use_point}<span className='use-point-text'>ポイント</span></div>
            </div>
            <div className="frame42">
              <div className='frame41'>
                <div className="ticket-detail">{Common.getBrString(ticket.ticket_summary)}</div>
                <button
                  onClick={() => ticketIssueClick(ticket.issue_count, ticket.ticket_id)}
                  className="button text-black bg-lightwhite">
                  ポイントを使う
                </button>
              </div>
            </div>
          </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default TicketIssuePaidList;
